/**
 * "View as" role switching: effective `user.role` differs from login `user.trueRole`.
 * Sidebar + permissionHelper use these rules so Super Admin / Admin do not keep
 * super-grants while viewing as Nurse, etc.
 */

/** Sidebar `permission` keys allowed per effective role when impersonating */
const VIEW_AS_SIDEBAR_MODULES_BY_ROLE = {
  Admin: [
    "Dashboard",
    "Consultation",
    "Patients",
    "Appointments",
    "Nursing",
    "Pathology",
    "Pharmacy",
    "Radiology",
    "Store",
    "Billing & Payments",
    "Reports",
    "User",
    "Settings",
    "Master",
  ],
  Nurse: ["Dashboard", "Patients", "Appointments", "Nursing"],
  Reception: ["Dashboard", "Patients", "Appointments"],
  HR: ["Dashboard", "Reports", "User"],
  HOD: [
    "Dashboard",
    "Patients",
    "Consultation",
    "Appointments",
    "Reports",
    "Nursing",
    "Pathology",
  ],
  Doctors: [
    "Dashboard",
    "Patients",
    "Consultation",
    "Appointments",
    "Pathology",
    "Radiology",
    "Nursing",
  ],
};

export function isViewingAs(user) {
  return Boolean(
    user?.trueRole && user?.role && String(user.role) !== String(user.trueRole)
  );
}

export function viewRoleAllowsSidebarModule(role, modulePermission) {
  if (!role || !modulePermission) return false;
  const list = VIEW_AS_SIDEBAR_MODULES_BY_ROLE[role];
  if (!list) return false;
  return list.includes(modulePermission);
}

function crudResourceToSidebarModule(resource) {
  if (!resource) return resource;
  const map = {
    Users: "User",
    Roles: "Role",
    Billing: "Billing & Payments",
  };
  return map[resource] || resource;
}

/** Used by permissionHelper for dotted permissions (e.g. Patients.Create) */
export function viewRoleAllowsPermission(role, permission) {
  if (!role || !permission) return false;
  if (viewRoleAllowsSidebarModule(role, permission)) return true;
  if (!permission.includes(".")) return false;
  const resource = permission.split(".")[0];
  const module = crudResourceToSidebarModule(resource);
  return viewRoleAllowsSidebarModule(role, module);
}
